<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">イケス一覧</h2>
            </v-col>
            <v-col class="text-right mt-3">
                <v-btn small color="success" @click="openDlgClick(0)"><h3>追加</h3></v-btn>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbDevices" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4>管理番号：{{ obj.sort_no }}</h4>
                        <h4>MAC：{{ obj.mac }}</h4>
                        <h4>給餌機：{{ feederName(obj.feeder_id) }}</h4>
                        <h4>環境センサー：{{ sensorName(obj.sensor_id) }}</h4>
                        <h4>カメラ1：{{ cameraName(obj.camera1_id) }}</h4>
                        <h4>カメラ2：{{ cameraName(obj.camera2_id) }}</h4>
                        <h4>カメラ3：{{ cameraName(obj.camera3_id) }}</h4>
                        <h4>カメラ4：{{ cameraName(obj.camera4_id) }}</h4>
                        <h4>AIカメラ：{{ cameraName(obj.ai_camera_id) }}</h4>
                        <h4>AIサーバURL：{{ obj.ai_server_url }}</h4>
                        <h4>電源：{{ obj.ontime }} 〜 {{ obj.offtime }}</h4>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn small @click="openInformation(obj)"><v-icon>mdi-information-variant</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showInfoDlg" max-width="400px">
            <v-card>
                <v-toolbar color="blue darken-2" dark>
                    <h4>{{ dlgInfo.name }}</h4>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showInfoDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <h4>mac: {{ dlgInfo.mac }}</h4>
                    <h4>device id: {{ dlgInfo.id }}</h4>
                    <h4>global ip: {{ dlgInfo.ipv4 }}</h4>
                    <h4>local ip: {{ dlgInfo.local_ip }}</h4>
                    <h4>sd ver: {{ dlgInfo.sd_ver }}</h4>
                    <h4>uptime: {{ $moment(dlgInfo.rpi_up_at).format("YYYY-MM-DD HH:mm:ss") }}</h4>
                    <h4>alive: {{ $moment(dlgInfo.alived_at).format("YYYY-MM-DD HH:mm:ss") }}</h4>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgDevice.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field label="管理番号" v-model="dlgDevice.sort_no" outlined dense type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field label="名前" v-model="dlgDevice.name" outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-text-field label="MACアドレス" v-model="dlgDevice.mac" outlined dense></v-text-field>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-select label="給餌機" v-model="dlgDevice.feeder_id" :items="optFeeders" outlined dense hide-details :disabled="usingPlan(dlgDevice.id, dlgDevice.feeder_id)"></v-select>
                                            <div class="text-right red--text" v-show="usingPlan(dlgDevice.id, dlgDevice.feeder_id)">給餌プランで利用中のためロックされています</div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select label="環境センサー" v-model="dlgDevice.sensor_id" :items="optSensors" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select label="カメラ1" v-model="dlgDevice.camera1_id" :items="optCameras" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select label="カメラ2" v-model="dlgDevice.camera2_id" :items="optCameras" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select label="カメラ3" v-model="dlgDevice.camera3_id" :items="optCameras" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select label="カメラ4" v-model="dlgDevice.camera4_id" :items="optCameras" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select label="AIカメラ" v-model="dlgDevice.ai_camera_id" :items="optCameras" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field label="AIサーバURL" v-model="dlgDevice.ai_server_url" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row v-show="dlgDevice.sd_ver >= '20230614'">
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-select label="電源On" v-model="dlgDevice.ontime" :items="optOntime" outlined dense hide-details></v-select>
                                        </v-col>
                                        <v-col>
                                            <v-select label="電源Off" v-model="dlgDevice.offtime" :items="optOfftime" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                    <div class="red--text">・この時間外は環境センサ値が取得できません。</div>
                                    <div class="red--text">・タイムラプスは、この時間内に設定してください。</div>
                                    <div class="red--text">・カメラ電源が切れるため、この時間外にAI給餌を行うと誤動作する恐れがあります。</div>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0" v-show="dlgDevice.id > 0">
                            <v-btn color="error" @click="showDelDlg = true" width="100" :disabled="usingPlan(dlgDevice.id, dlgDevice.feeder_id)">削除</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showDelDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgDevice.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDelete()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="showDelDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
export default {
    name: "Devices",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showInfoDlg: false,
            showEditDlg: false,
            showDelDlg: false,
            isLoading: false,
            dbDevices: [],
            dbFeeders: [],
            dbSensors: [],
            dbCameras: [],
            dbFeedPlans: [],
            optFeeders: [],
            optSensors: [],
            optCameras: [],
            optOntime: [
                { text: "00:00", value: "00:00" },
                { text: "01:00", value: "01:00" },
                { text: "02:00", value: "02:00" },
                { text: "03:00", value: "03:00" },
                { text: "04:00", value: "04:00" },
                { text: "05:00", value: "05:00" },
                { text: "06:00", value: "06:00" },
                { text: "07:00", value: "07:00" },
                { text: "08:00", value: "08:00" },
                { text: "09:00", value: "09:00" },
            ],
            optOfftime: [
                { text: "17:00", value: "17:00" },
                { text: "18:00", value: "18:00" },
                { text: "19:00", value: "19:00" },
                { text: "20:00", value: "20:00" },
                { text: "21:00", value: "21:00" },
                { text: "22:00", value: "22:00" },
                { text: "23:00", value: "23:00" },
                { text: "24:00", value: "24:00" },
            ],
            dlgInfo: {
                ipv4: "",
                local_ip: "",
                sd_ver: "",
            },
            dlgDevice: {
                id: 0,
                site_id: 0,
                mac: "ff:ff:ff:ff:ff:ff",
                name: "Newイケス",
                sort_no: 999,
                ontime: null,
                offtime: null,
            },
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseDevice = this.axiosGetDevices();
        const promiseFeeder = this.axiosGetFeeders();
        const promiseSensor = this.axiosGetSensors();
        const promiseCamera = this.axiosGetCameras();
        const promiseFeedPlans = this.axiosGetFeedPlans();
        //-----------------------
        //上記の終了を待つ
        await promiseDevice;
        await promiseFeeder;
        await promiseSensor;
        await promiseCamera;
        await promiseFeedPlans;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    computed: {},
    //========================================================
    methods: {
        //===================================================
        feederName: function (id) {
            let ret = "";
            for (let obj of this.optFeeders) if (obj.value == id) ret = obj.text;
            return ret;
        },
        sensorName: function (id) {
            let ret = "";
            for (let obj of this.optSensors) if (obj.value == id) ret = obj.text;
            return ret;
        },
        cameraName: function (id) {
            let ret = "";
            for (let obj of this.optCameras) if (obj.value == id) ret = obj.text;
            return ret;
        },
        //===================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
            });
        },
        //===================================================
        async axiosGetFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeders = response.data.json;
                this.optFeeders = [{ text: "-----", value: 0 }];
                for (let item of this.dbFeeders) {
                    this.optFeeders.push({ text: item.name, value: item.id });
                }
            });
        },
        //===================================================
        async axiosGetSensors() {
            await this.axios({
                method: "GET",
                url: "/web/api/sensors",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSensors = response.data.json;
                this.optSensors = [{ text: "-----", value: 0 }];
                for (let item of this.dbSensors) {
                    this.optSensors.push({ text: item.name, value: item.id });
                }
            });
        },
        //===================================================
        async axiosGetCameras() {
            await this.axios({
                method: "GET",
                url: "/web/api/cameras",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbCameras = response.data.json;
                this.optCameras = [{ text: "-----", value: 0 }];
                for (let item of this.dbCameras) {
                    this.optCameras.push({ text: item.name, value: item.id });
                }
            });
        },
        //===================================================
        // 給餌プランDataを取得
        //===================================================
        async axiosGetFeedPlans() {
            await this.axios({
                method: "GET",
                url: "/web/api/feed_plans",
                headers: { Authorization: "Bearer " + this.jwt },
                params: {
                    _fields: "id,device_id,feeder_id",
                    //device_id: this.device_id
                },
                timeout: 30000,
            }).then((response) => {
                this.dbFeedPlans = response.data.json;
            });
        },
        //===================================================
        // 給餌プランで、既に使用されているか？
        //===================================================
        usingPlan(device_id, feeder_id) {
            let useCounter = 0;
            for (let obj of this.dbFeedPlans) {
                if (obj.device_id == device_id && obj.feeder_id == feeder_id) useCounter++;
            }
            return useCounter > 0 ? true : false;
        },
        //===================================================
        // 確認ダイアログ表示
        //===================================================
        openInformation(device) {
            // this.dlgInfo.ipv4 = device.ipv4;
            // this.dlgInfo.local_ip = device.local_ip;
            // this.dlgInfo.sd_ver = device.sd_ver;
            this.dlgInfo = device;
            this.showInfoDlg = true;
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            if (primaryKey) {
                for (let obj of this.dbDevices) {
                    if (obj.id == primaryKey) {
                        this.dlgDevice = JSON.parse(JSON.stringify(obj));
                    }
                }
            } else {
                this.dlgDevice["id"] = 0;
                this.dlgDevice["name"] = "新規イケス";
                this.dlgDevice["sort_no"] = "1";
                this.dlgDevice["mac"] = "xx:xx:xx:xx:xx:xx";

                this.dlgDevice["feeder_id"] = 0;
                this.dlgDevice["sensor_id"] = 0;
                this.dlgDevice["camera1_id"] = 0;
                this.dlgDevice["camera2_id"] = 0;
                this.dlgDevice["camera3_id"] = 0;
                this.dlgDevice["camera4_id"] = 0;
                this.dlgDevice["ai_camera_id"] = 0;
                this.dlgDevice["ai_server_url"] = "";
                this.dlgDevice["ontime"] = "00:00";
                this.dlgDevice["offtime"] = "24:00";

                delete this.dlgDevice["sd_ver"];
                delete this.dlgDevice["alived_at"];
                delete this.dlgDevice["modified"];
            }
            this.showEditDlg = true;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgDevice["name"]) ErrCount++;
            if (!this.dlgDevice["mac"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgDevice));
            axiosData["site_id"] = this.myInfo.site_id;
            axiosData["is_active"] = 1;
            delete axiosData["ipv4"];
            delete axiosData["local_ip"];
            delete axiosData["sd_ver"];
            delete axiosData["rpi_up_at"];
            delete axiosData["alived_at"];
            delete axiosData["modified"];
            //-----------------------------------
            const primaryKey = this.dlgDevice.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/devices";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetDevices();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("MACアドレスが重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 100));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosDelete() {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgDevice.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/devices/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetDevices();
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
